import React from "react";
import Title from "../../../Common/Title";
import img1 from "../../../../Assets/Images/img-price-banner@3x.png";
import img2 from "../../../../Assets/Images/ic-whatis-mornitoring-02@3x.png";
import img3 from "../../../../Assets/Images/ic-whatis-mornitoring-03@3x.png";
import img4 from "../../../../Assets/Images/ic-whatis-mornitoring-04@3x.png";
import "./styles.scss";
import Button from "../../../Common/Button";
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../../Modules/routesString";
import * as Scroll from "react-scroll"

function FREEplatform() {
  const navigation = useNavigate()
  const scroll = Scroll.animateScroll
  return (
    <div className="FREEplatform">
      <div className="FREEplatform-container">
        <Title
          title={
            <>
              <span style={{ color: "#fff" }}> 에드업 CSbye 플랫폼 플랜</span>
            </>
          }
          detail={`성장하는 기업에 전문적인 고객관리 서비스가 필요하다면?`}
        />
              <img src={img1} alt="" />
    
            <div className="mornitoringService-container-button">
                <Button onClick={() => {
                  scroll.scrollToTop()
                  navigation(RoutesString.Price)
                  }} rightIcon text="CSbye 플랫폼 플랜 보러가기" />
            </div>

      </div>
    </div>
  );
}

export default FREEplatform;

